const telefone_validation = (telefone) => {
    //retira todos os caracteres menos os numeros
    telefone = telefone.replace(/\D/g, '');

    //verifica se tem a qtde de numero correto
    if (!(telefone.length >= 10 && telefone.length <= 11)) return false;

    //Se tiver 11 caracteres, verificar se começa com 9 o celular
    if (telefone.length == 11 && parseInt(telefone.substring(2, 3)) != 9) return false;

    //verifica se não é nenhum numero digitado errado (propositalmente)
    for (var n = 0; n < 10; n++) {
        if (telefone == new Array(11).join(n) || telefone == new Array(12).join(n)) return false;
    }

    var codigosDDD = [11, 12, 13, 14, 15, 16, 17, 18, 19,
        21, 22, 24, 27, 28, 31, 32, 33, 34,
        35, 37, 38, 41, 42, 43, 44, 45, 46,
        47, 48, 49, 51, 53, 54, 55, 61, 62,
        64, 63, 65, 66, 67, 68, 69, 71, 73,
        74, 75, 77, 79, 81, 82, 83, 84, 85,
        86, 87, 88, 89, 91, 92, 93, 94, 95,
        96, 97, 98, 99];

    if (codigosDDD.indexOf(parseInt(telefone.substring(0, 2))) == -1) return false;
    if (new Date().getFullYear() < 2017) return true;

    return true;
}

// const formata_telefone = (v) => {
//     var v1 = v.replace(/\D/g,"");
//     var v2 = v1.replace(/^(\d{2})(\d)/g,"($1) $2");
//     var v3 = v2.replace(/(\d)(\d{4})$/,"$1-$2");
    
//     return v3;
// }

const { parsePhoneNumberFromString } = require('libphonenumber-js');

const formata_telefone = (v) => {
    //console.log('TELEFONE: ',v);
    try {
        // parse the phone number string to a phone number object
        const phoneNumber = parsePhoneNumberFromString('+' + v);
        if (!phoneNumber) {
          return null;
        }
        if (phoneNumber.country === 'BR') {
              // Número de telefone nacional (com DDD)
              if(phoneNumber.number.length == 13){
                const formattedPhoneNumber = phoneNumber.number.replace(/(\+55)(\d{2})(\d{4,5})(\d{4})/, '$1 ($2) $3-$4');
                return formattedPhoneNumber;
              }
              return '+55 ' + phoneNumber.formatNational();
        } else {
            // Número de telefone internacional
              return phoneNumber.formatInternational();
        }
    } catch (error) {
          console.log('Erro ao formatar o número de telefone:', error);
    }
}

export default {
    telefone_validation,
    formata_telefone
}
